import React from "react";
import { Center } from "@/shared/ui/Blocks";
import Rive from "@rive-app/react-canvas";
import assessioaiLoaderUrl from "./assessioai_loader.riv?url";

interface CirclesLoaderProps {
  loading?: boolean;
}

const CirclesLoader: React.FC<CirclesLoaderProps> = ({ loading = true }) => {
  if (!loading) return null;

  return (
    <Center className="relative m-4 min-h-[150px] min-w-[150px]">
      <Rive src={assessioaiLoaderUrl} className="w-[150px] h-[150px]" />
    </Center>
  );
};

export default CirclesLoader;
